<template lang='pug'>
  i.svg-icon.svg-icon-youtube
    svg(
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 100 100')

      path(fill='#E6211B' d='M51.73,80.55c-10.59-0.46-20.03-0.85-29.46-1.31c-1.69-0.08-3.38-0.36-5.03-0.69c-4.74-0.95-7.94-4.5-8.81-9.76 c-1.41-8.57-1.64-17.21-1.18-25.87c0.21-3.94,0.57-7.89,1.17-11.79c1-6.54,4.74-9.95,11.3-10.55c16.47-1.51,32.98-1.44,49.49-0.78 c4.45,0.18,8.92,0.53,13.34,1.09c5.74,0.73,9.06,4.1,10.05,9.84c1.48,8.57,1.63,17.21,1.18,25.87c-0.21,4.06-0.61,8.12-1.2,12.13 c-0.9,6.16-4.67,9.76-10.84,10.18C71.37,79.6,60.98,80.06,51.73,80.55z M41.93,62.77c7.56-4.36,14.91-8.59,22.52-12.97 c-7.61-4.38-14.98-8.63-22.52-12.97C41.93,45.55,41.93,54,41.93,62.77z')

</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#333',
    },
  },
};

</script>
